import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTickCircleinline = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		fillRule: "evenodd",
		children: [/* @__PURE__ */ _jsx("circle", {
			cx: 12,
			cy: 12,
			r: 11,
			stroke: "#000",
			strokeWidth: 2
		}), /* @__PURE__ */ _jsx("polyline", {
			stroke: "#000",
			strokeLinecap: "square",
			strokeLinejoin: "round",
			strokeWidth: 2,
			points: "8 13.72 10.926 16 16 8"
		})]
	})
});
export default SvgTickCircleinline;
